import { render, staticRenderFns } from "./NotebookEdit.vue?vue&type=template&id=31f1d239&scoped=true"
import script from "./NotebookEdit.vue?vue&type=script&lang=js"
export * from "./NotebookEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f1d239",
  null
  
)

export default component.exports